import React from 'react';
import { Bell, CircleHelp, LogOut, UploadCloud } from 'lucide-react';
import Button from '../ui/Button';
import { getStoredDataset } from '../../services/analytics';
import { logout } from '../../services/authentication';

const mobileLinks = [
  { name: 'Overview', path: '/dashboard' },
  { name: 'Upload', path: '/upload' },
  { name: 'Analytics', path: '/analytics' },
  { name: 'Ask', path: '/ask' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'Settings', path: '/settings' },
];

const pageTitles: Record<string, string> = {
  '/dashboard': 'Overview',
  '/upload': 'Upload',
  '/review': 'Review data',
  '/analytics': 'Analytics',
  '/ask': 'Ask GabMic',
  '/pricing': 'Pricing',
  '/billing/callback': 'Billing',
  '/settings': 'Settings',
};

const TopNavbar: React.FC = () => {
  const activePath = window.location.pathname;
  const dataset = getStoredDataset();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      window.location.assign('/signin');
    }
  };

  const navStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.8rem',
    minHeight: '73px',
    padding: '0.9rem 2rem',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.006)), #0B0B0B',
    borderBottom: '1px solid var(--border-color)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  };

  return (
    <header style={navStyle}>
      <div>
        <strong style={{ fontSize: '1.05rem' }}>{pageTitles[activePath] ?? 'Overview'}</strong>
        {dataset && (
          <span className="desktop-only" style={{ marginLeft: '1rem', color: 'var(--text-muted)', fontSize: '0.86rem' }}>
            {dataset.fileName}
          </span>
        )}
      </div>

      <nav className="desktop-only" style={{ display: 'flex', gap: '0.35rem', alignItems: 'center' }}>
        {mobileLinks.map((link) => (
          <a
            key={link.name}
            href={link.path}
            style={{
              padding: '0.45rem 0.7rem',
              borderRadius: '6px',
              color: activePath === link.path ? 'var(--text-main)' : 'var(--text-secondary)',
              backgroundColor: activePath === link.path ? 'var(--bg-background)' : 'transparent',
              fontSize: '0.875rem',
              fontWeight: 600,
            }}
          >
            {link.name}
          </a>
        ))}
      </nav>

      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
        <button className="icon-button" type="button" title="Notifications" aria-label="Notifications">
          <Bell size={18} />
        </button>
        <a className="icon-button" href="/#about" title="About GabMic" aria-label="About GabMic">
          <CircleHelp size={18} />
        </a>
        <a href="/upload">
          <Button variant="primary" size="sm">
            <UploadCloud size={16} />
            <span style={{ marginLeft: '0.45rem' }}>Upload data</span>
          </Button>
        </a>
        <Button variant="outline" size="sm" onClick={handleLogout}>
          <LogOut size={16} />
          <span style={{ marginLeft: '0.45rem' }}>Logout</span>
        </Button>
      </div>
    </header>
  );
};

export default TopNavbar;
